import { Navigate, Route, Routes } from 'react-router-dom'
import { AuthProvider } from './components/AuthProvider.jsx'
import { InventoryProvider } from './components/InventoryProvider.jsx'
import ProtectedRoute from './components/ProtectedRoute.jsx'
import { ToastProvider } from './components/ToastProvider.jsx'
import AppLayout from './layouts/AppLayout.jsx'
import DashboardPage from './pages/DashboardPage.jsx'
import InventoryPage from './pages/InventoryPage.jsx'
import LoginPage from './pages/LoginPage.jsx'
import PartDetailPage from './pages/PartDetailPage.jsx'
import PartEditPage from './pages/PartEditPage.jsx'
import PartNewPage from './pages/PartNewPage.jsx'
import ReviewPage from './pages/ReviewPage.jsx'
import SettingsPage from './pages/SettingsPage.jsx'
import RequestsPage from './pages/RequestsPage.jsx'
import TransactionsPage from './pages/TransactionsPage.jsx'
import UsersPage from './pages/UsersPage.jsx'
import ProjectsPage from './pages/ProjectsPage.jsx'
import { canManageParts, canManageProjects, canManageUsers } from './utils/permissions'

export default function App() {
  return (
    <AuthProvider>
      <InventoryProvider>
        <ToastProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route element={<ProtectedRoute />}>
              <Route element={<AppLayout />}>
                <Route path="/" element={<DashboardPage />} />
                <Route path="/inventory" element={<InventoryPage />} />
                <Route element={<ProtectedRoute allow={canManageParts} />}>
                  <Route path="/inventory/review" element={<ReviewPage />} />
                  <Route path="/inventory/new" element={<PartNewPage />} />
                  <Route path="/inventory/:id/edit" element={<PartEditPage />} />
                </Route>
                <Route path="/inventory/:id" element={<PartDetailPage />} />
                <Route path="/transactions" element={<TransactionsPage />} />
                <Route path="/requests" element={<RequestsPage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route element={<ProtectedRoute allow={canManageProjects} />}>
                  <Route path="/settings/projects" element={<ProjectsPage />} />
                </Route>
                <Route element={<ProtectedRoute allow={canManageUsers} />}>
                  <Route path="/settings/users" element={<UsersPage />} />
                </Route>
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </ToastProvider>
      </InventoryProvider>
    </AuthProvider>
  )
}
